var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconSend = function SvgIconSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.074 1c.166 0 .33.039.48.113L18.406 9.04a1.074 1.074 0 0 1 0 1.92L2.554 18.886A1.074 1.074 0 0 1 1 17.926v-6.5C1.003 10.146 2 10 2 10l-.023-.005C1.827 9.962 1 9.72 1 8.48V2.074C1 1.48 1.48 1 2.074 1Zm.949 3.096A.25.25 0 0 0 3 4.2v3.816l.008.135a.935.935 0 0 0 .26.584c.177.176.423.265.738.265H10a1 1 0 0 1 .992.883L11 10l-.007.116a1 1 0 0 1-.992.883H4.006c-.315 0-.56.089-.738.265-.177.176-.266.421-.268.736v-.017 3.816a.25.25 0 0 0 .354.227l12.689-5.799a.25.25 0 0 0 0-.455l-12.69-5.8a.25.25 0 0 0-.33.124Z",
    fillRule: "evenodd"
  })));
};

export default SvgIconSend;